import { OPTIONS, MENU_ID } from './constants'

export const wantInsertVariable = evt => evt.nativeEvent.key === '{'

export const closingVariable = evt => evt.nativeEvent.key === '}'

export const isDeleting = evt => evt.nativeEvent.key === 'Backspace'

export const isDeletingVariable = (preText, text) => {
  const removed = preText.slice(-1)
  const result = preText.slice(0, -1)
  const removing = preText.length === text.length + 1 && result === text
  return removing && removed === '}'
}

export const searchingOption = evt => {
  if (evt.nativeEvent.key === 'ArrowDown') return evt.nativeEvent.key
  if (evt.nativeEvent.key === 'ArrowUp') return evt.nativeEvent.key
  return false
}

export const isEnter = evt => evt.nativeEvent.key === 'Enter'

export const removingVariable = (evt, text) =>
  isDeleting(evt) && text.length > 0 && text[text.length - 1] === '{'

export const updateRowsCount = id => {
  const input = document.getElementById(id)
  input.rows = 1
  const size = window.getComputedStyle(input, null).getPropertyValue('line-height')
  input.rows = input.scrollHeight / parseFloat(size)
}

export const moveToLastCharacter = evt => {
  const textarea = evt.target
  const length = textarea.value.length
  textarea.setSelectionRange(length, length)
  textarea.focus()
}

export const moveCursor = (id, position) => {
  const element = document.getElementById(id)
  element.focus()
  element.setSelectionRange(position, position)
}

export const removeVariable = (text, variable, position) =>
  text.slice(0, position - variable.length) + text.slice(position, text.length)

export const insertVariable = (text, variableName, variableCode, position) => {
  const parsedText = removeVariable(text, variableName, position)
  const newPosition = position - variableName.length
  const firstPart = parsedText.substr(0, newPosition - 1) + variableCode
  const secondPart = parsedText.substr(newPosition, parsedText.length)

  return {
    text: firstPart + secondPart,
    position: firstPart.length
  }
}

export const getVariableName = id => {
  const { value, selectionStart: position } = document.getElementById(id)
  const chars = value.replace(`[\n]+`, ' ').slice(0, position).split('{')
  return chars[chars.length - 1]
}

export const filterOptions = (options, value) =>
  options.filter(({ text }) => text.toLowerCase().includes(value.toLowerCase()))

const getMenuWidth = () => {
  const dropdown = document.getElementById(MENU_ID)
  const menu = dropdown ? dropdown.children[2] : null
  const width = menu ? menu.getBoundingClientRect().width : 0
  return width
}

const copyStyles = (from, to) => {
  const styles = window.getComputedStyle(from)
  const cssText =
    styles.cssText ||
    Array.from(styles).reduce(
      (str, property) => `${str}${property}:${styles.getPropertyValue(property)};`,
      ''
    )
  to.style.cssText = cssText
}

const createDummyElement = (id, input) => {
  input.insertAdjacentHTML('afterend', `<div id=${id} />`)
  const dummy = document.getElementById(id)
  copyStyles(input, dummy)
  return dummy
}

const insertDummyElement = (input, text) => {
  const dummyId = 'dummy'
  const dummy = createDummyElement(dummyId, input)
  const span = document.createElement('span')

  text.split('\n').forEach(line => {
    line.split('').forEach(d => {
      span.textContent = d
      dummy.appendChild(span.cloneNode(true))
    })
    dummy.appendChild(document.createElement('br'))
  })

  return dummy
}

export const getWidth = inputId => {
  const input = document.getElementById(inputId)
  const dummyId = 'get-width-dummy'
  const dummy = createDummyElement(dummyId, input)
  dummy.textContent = input.value
  dummy.style.width = 'fit-content'
  const { width } = dummy.getBoundingClientRect()
  dummy.remove()
  return width
}

const getCursor = id => {
  const input = document.getElementById(id)
  const dummy = insertDummyElement(input, input.value)
  const index = input.selectionStart
  const { bottom, right } = dummy.children[index - 1].getBoundingClientRect()
  const { x, y } = dummy.getBoundingClientRect()
  dummy.remove()

  return {
    y: bottom - y,
    x: right - x,
    position: input.selectionStart,
    maxX: input.getBoundingClientRect().width
  }
}

export const moveToCursor = (elementId, inputId, fitContent) => {
  const element = document.getElementById(elementId)
  const inputElement = document.getElementById(inputId)
  if (element) {
    const { x, y, maxX } = getCursor(inputId)
    const menuWidth = getMenuWidth()
    const maxMenuPosition = maxX - menuWidth
    let xEnd = x
    if (x > maxMenuPosition) {
      if (maxMenuPosition > 0) {
        xEnd = maxMenuPosition
      } else {
        xEnd = 0
      }
    }

    element.style.left = `${xEnd}px`
    element.style.top = `${
      fitContent ? inputElement.getBoundingClientRect().height : y
    }px`
  }
}

const findCharIndex = (list_a, list_b) =>
  list_a.findIndex((char, index) => list_b[index] !== char)

const getTextDeleted = (oldValue, newValue) => {
  const newValueSplitted = newValue.split('')
  const newValueSplittedReverse = newValue.split('').reverse()
  const oldValueSplitted = oldValue.split('')

  const firstIndex = findCharIndex(oldValueSplitted, newValueSplitted)

  const lastIndex =
    oldValue.length -
    findCharIndex(oldValueSplitted.reverse(), newValueSplittedReverse)

  return { text: oldValue.slice(firstIndex, lastIndex), position: firstIndex }
}

export const deleteVariable = (oldValue, newValue) => {
  const { text, position } = getTextDeleted(oldValue, newValue)

  if (text === '}') {
    for (let i = 0; i < OPTIONS.length; i += 1) {
      const { value } = OPTIONS[i]
      const from = position - value.length + 1
      const to = position + 1
      const variable = oldValue.slice(from, to)

      if (variable === value) {
        const firstPart = oldValue.slice(0, from)
        const secondPart = oldValue.slice(to, oldValue.length)

        return {
          text: firstPart + secondPart,
          cursorPosition: firstPart.length
        }
      }
    }
  }

  return null
}
